import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Checkbox, Grid, Header, Icon, Input, Label, Message, Modal, Table } from 'semantic-ui-react';
import { handleDownload } from '../../helpers/downloads';
import { addPositions, checkForUpdates, fetchAsset, fetchInstallations, fetchInstallationsFilters, fetchOrganisationByPosition, removeAsset, setActiveInstallation, setAsset, setAuthorise, setEft, showSuccessAlert } from '../../redux/actions';
import { fetchInstallationsExport } from '../../redux/actions/installations';
import { prepareFilter } from '../../redux/actions/organisationDirectory';
import OptionsModal from '../modals/OptionsModal';
import DataGrid from '../shared/DataGrid';
import DownloadButton from '../shared/DownloadButton';
import SettingsButton from '../shared/SettingsButton';

class SiteInstallations extends React.Component {

  initialValues = {
    activeOrg: null,
    activeSubOrg: null,
    editableMachine: false,
    installMachine: false,
    removeMachine: false,
    authInstall: false,
    organisation: null,
    modalInstallOpen: false,
    modalEditOpen: false,
    modalDeleteOpen: false,
    modalAddPosition: false,
    installations: {date:[],headerDef:[]},
    eftLabel: "",
    eftActive: null,
    AllowSuspendEnableEFT: false,
    loading: false,
    numPositions: "",
    addPositionError: false,
    modalErrorOpen: false,
    errorModalTitle: 'An Error Occured',
    errorModalContent: 'An unknown error occured.',
    removeLoading: false,
    assetNo: '',
    modalOpen: false,
    modalOptions: [],
    modalTitle: "Install Machine",
    modalSave: () => {},
    modalReload: () => {},
  }

  state = {
    showOfflineOnly: false,
    showHistory: false,
    ...this.initialValues
  }

  resetState(){
    this.setState({...this.initialValues})
  }

  onRowClick = installation =>{
    //get the index from id
    const allowSuspendEnableEFT = (installation.optionAllowDisableEFT || installation.optionAllowEnableEFT)?true:false;
    var eftLabel;
    var eftActive;
    if(installation.optionAllowDisableEFT){
      eftLabel = "Disable";
      eftActive = true;
    }
    if(installation.optionAllowEnableEFT){
      eftLabel = "Enable";
      eftActive = false;
    }

    this.setState({
      activeInstallation: installation,
      activeSiteRef: "",
      editableMachine: installation.optionModify,
      installMachine: installation.optionInstall,
      authInstall: installation.optionAllowAuthorise,
      AllowSuspendEnableEFT: allowSuspendEnableEFT,
      removeMachine: installation.optionAllowRemove,
      eftLabel: eftLabel,
      eftActive: eftActive,
    }, () => {
      this.props.setActiveInstallation(installation)
    });
  }

  handleModalChange = ({ target }) => {
    this.setState(state => {
      if(state[target.name]){
        this.handleInstallationRefresh();
      }
      return {[target.name]: !state[target.name]}
    });
  };

  handleChange = ({ target }) => {
     const name = target.name;
     const value = target.value;
     if (this.state.hasOwnProperty(name)) {
       this.setState({ [name]: value });
     }
  }

  eftClick = () => {
    this.props.setEft(this.state.activeInstallation.installationId, this.state.eftActive).then(()=>{
      if(this.props.eftUpdate === 'OK'){
        this.handleInstallationRefresh();
      }else{
        this.setState({
          modalDeleteOpen: false,
          modalErrorOpen: true,
          errorModalTitle: 'EFT Update failed',
          errorModalContent: 'There was an error while while trying to update the EFT state.',
        })
      }
    });
  }

  autoriseClick = () => {
    this.props.setAuthorise(this.state.activeInstallation.installationId).then(()=>{
      if(this.props.authorise === 'OK'){
        this.handleInstallationRefresh();
      }else{
        this.setState({
          modalDeleteOpen: false,
          modalErrorOpen: true,
          errorModalTitle: 'Unable Authorise',
          errorModalContent: 'There was an error while trying to authorise.',
        })
      }
    });
  }

  removeClick = () => {
    this.setState({ removeLoading: true }, () => {
      removeAsset(this.state.activeInstallation.installationId).then(
        () => this.setState({ removeMachine: false, removeLoading: false }, () => this.handleInstallationRefresh()),
        () => this.setState({ removeMachine: false, removeLoading: false })
      );
    });
  }

  refreshClick = () => {
    this.resetState();
    this.props.setActiveInstallation().then(() => {
      this.handleInstallationRefresh();
    })
  }

  handleInstallationRefresh = () => {
    this.setState({loading: true }, () => {
      const { filterSelected, filterData } = this.props.filters
      this.props.fetchInstallations(
        this.props.filters.filterSelected.operator,
        this.props.organisationId,
        this.state.showHistory,
        prepareFilter(filterSelected.regions, filterData.regions),
        prepareFilter(filterSelected.manufacturer, filterData.manufacturer),
        prepareFilter(filterSelected.game, filterData.game),
        prepareFilter(filterSelected.machinetypes, filterData.machinetypes),
        this.state.showOfflineOnly
      ).then(() => {
        this.setState({loading: false });
      })
      .catch(() => {
        this.setState({loading: false});
      });
    });
  }
  
  handleDownloadClick = () => {
    const date = moment().format('YYYY-MM-DD');
    this.setState({downloadLoading: true }, () => {
      const { filterSelected, filterData } = this.props.filters
      fetchInstallationsExport(
        this.props.filters.filterSelected.operator,
        this.props.organisationId,
        this.state.showHistory,
        prepareFilter(filterSelected.regions, filterData.regions),
        prepareFilter(filterSelected.manufacturer, filterData.manufacturer),
        prepareFilter(filterSelected.game, filterData.game),
        prepareFilter(filterSelected.machinetypes, filterData.machinetypes),
        this.state.showOfflineOnly
      ).then(
        response => this.setState({downloadLoading: false }, () => handleDownload('Current Instalations ' + date, response)),
        () => this.setState({downloadLoading: false})
     );
    });
  }

  addPositions = () => {
    this.props.addPositions(this.props.organisationId, this.state.numPositions).then(()=>{
      if(this.props.positionsAdd === 'OK'){
        this.handleInstallationRefresh();
        this.setState({modalAddPosition: false, addPositionError: false });
      }else {
        this.setState({addPositionError: true });
      }
    });
  }

  handleHistoryChange = () => {

    this.setState({ showHistory: !this.state.showHistory }, () => {
      this.handleInstallationRefresh()
    });
  }

  componentDidUpdate(prevProps){
    // Check for a change in the transaction list
    if(this.props.installations !== prevProps.installations){
      this.resetState();
    }
    if (checkForUpdates(prevProps.filters, this.props.filters)) {
      this.props.setActiveInstallation({}).then(() => this.handleInstallationRefresh());
    }
  }

  selectMachine = () => {
    this.fetchAsset(this.state.assetNo, this.state.activeInstallation.positionId)
  }

  fetchAsset = (assetNo, positionId) => {
    this.setState({ modalOptions: [], modalLoading: true }, () => {
      fetchAsset(assetNo, positionId).then(result => {
        this.setState( { modalOptions: result.options, modalLoading: false })
      },
      () => {
        this.setState({ modalLoading: false })
      })
    });
  }


  handleSaveInstall = async (changes, another, complete) => {
    await setAsset(this.props.activeInstallation.positionId, this.state.assetNo, changes, complete).then(result => {
      if (!complete) {
        this.setState( { modalOptions: result.options })
      } else {
        this.setState({ assetNo: "" }, () => {
          this.props.showSuccessAlert(result).then(() => {
            this.handleInstallationRefresh();
          })
        })
      }
    })
  }

  handleEditMachine = () => {
    fetchOrganisationByPosition(this.props.activeInstallation.positionId).then(result => {
      this.setState({
        modalOptions: result.options,
        modalOpen: true,
        modalSave: this.handleSaveInstall,
        modalReload: this.handleSaveInstall,
        assetNo: result.assetNo,
        modalTitle: `Edit Machine  -  ${result.companySite}`
      })
    })
  }
  handleInstallMachine = () => {
    fetchOrganisationByPosition(this.props.activeInstallation.positionId).then(result => {
      this.setState({
        modalOptions: [],
        modalOpen: true,
        modalSave: this.handleSaveInstall,
        modalReload: this.handleSaveInstall,
        modalTitle: `Install Machine  -  ${result.companySite}`
      })
    })
  }

  leftControls = () => {
    const { logIn } = this.props;
    const { optionShowInstCollectionTabs } = logIn;
    const { showOfflineOnly } = this.state;
    const { online, offline } = this.props.installations;

    return (
      <>
        <div className="mb-1">
         <Label color="green" className="w-100 mb-0_25">
          Online
          <Label.Detail className="float-right">{online}</Label.Detail>
         </Label>
         <Label color="red" className="w-100 ml-0">
          Offline
          <Label.Detail className="float-right">{offline}</Label.Detail>
         </Label>
         <Checkbox className="mt-1" label='Show Offline Only' onClick={() => this.setState({ showOfflineOnly: !showOfflineOnly})} />
        </div>
        <div className="mb-1">
          {this.props.filters.hasSelection && <Button compact loading={this.state.loading} disabled={this.state.loading} onClick={this.refreshClick} size="small" positive fluid><Icon name="refresh" /> Refresh</Button>}
          <SettingsButton><Checkbox toggle label="Show History" onChange={this.handleHistoryChange} checked={this.state.showHistory} /></SettingsButton>
          { optionShowInstCollectionTabs && <Button compact fluid basic={this.props.expanded} secondary size="small" onClick={this.props.handleExpand} ><Icon name="expand" /> Expand</Button> }
          <DownloadButton fluid caption="Download" loading={this.state.downloadLoading} disabled={this.state.downloadLoading} onClick={this.handleDownloadClick} />
        </div>

        {this.state.modalErrorOpen && <Modal
          open={this.state.modalErrorOpen}
          size='small' className='width-auto'>
          <Header content={this.state.errorModalTitle} />
          <Modal.Content>
            <p>{this.state.errorModalContent}</p>
            <Button name="modalErrorOpen" disabled={this.state.loading} onClick={this.handleModalChange}>OK</Button>
          </Modal.Content>
        </Modal>
        }

        {/* Add Position button */}
        {this.props.organisationId && logIn.optionAllowAddPosition && <Modal
          trigger={(
            <Button
              name="modalAddPosition"
              disabled={this.state.loading}
              loading={this.state.loading}
              compact
              onClick={this.handleModalChange}
              size="small"
              fluid
            >
              <Icon name="add" />
              Add Position
            </Button>
          )}
          open={this.state.modalAddPosition}
          size='small'>
          <Header content={`Add Position`} />
          <Modal.Content>
            {this.state.addPositionError && <Message warning>There was an error check your input.</Message>}
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <label>Num Positions to add</label>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Input name="numPositions" value={this.state.numPositions} onChange={this.handleChange} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Button fluid onClick={this.addPositions}>Add Positions</Button>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Button fluid name="modalAddPosition" onClick={this.handleModalChange}>Cancel</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>}


        {this.state.AllowSuspendEnableEFT && <Button fluid disabled={this.state.loading} loading={this.state.loading} onClick={this.eftClick}>{this.state.eftLabel}</Button>}

        {this.state.authInstall && <Button fluid disabled={this.state.loading} loading={this.state.loading} onClick={this.autoriseClick}>Authorise Install</Button>}

        {/* Edit Machine button */}
        {this.state.editableMachine && <Button
          name='modalEditOpen'
          onClick={this.handleEditMachine}
          disabled={this.state.loading}
          compact
          loading={this.state.loading}
          size="small"
          fluid
        >
          Edit Machine
        </Button>
        }

        { /* Install Machine */}
        {this.state.installMachine &&
          <Button
            fluid
            compact
            disabled={this.state.loading}
            loading={this.state.loading}
            size="small"
            onClick={this.handleInstallMachine}>
            Install Machine
          </Button>
        }

        {/* Remove Machine button */}
        {this.state.removeMachine && <Modal
          trigger={(
            <Button
              name="modalDeleteOpen"
              loading={this.state.loading}
              disabled={this.state.loading}
              onClick={this.handleModalChange}
              compact
              size="small"
              negative
              fluid
            >
              Remove Machine
            </Button>
          )}
          open={this.state.modalDeleteOpen}
          size='small'>
          <Header content={`Remove Machine Asset`} />
          <Modal.Content>
            Are you sure you want to remove this machine?
          </Modal.Content>
          <Modal.Actions>
            <Button positive onClick={this.removeClick} disabled={this.state.removeLoading || this.state.loading} loading={this.state.removeLoading || this.state.loading}>Remove</Button>
            <Button negative name="modalDeleteOpen" disabled={this.state.loading} loading={this.state.loading} onClick={this.handleModalChange}>Cancel</Button>
          </Modal.Actions>
        </Modal>
        }
      </>
    )

  }


  render() {

    const { headerDef, rowDef, data } = this.props.installations.grid;

    const prefix = this.state.installMachine ? <Table.Row key={`EGM Asset No`}>
      <Table.Cell width="9">EGM Asset No: <span style={{ color: "#db2828"}}>*</span></Table.Cell>
      <Table.Cell width="7">
        <Input value={this.state.assetNo} onChange={(event, { value }) => this.setState({ assetNo: value })} />
        <Button disabled={this.state.modalLoading} loading={this.state.modalLoading} onClick={this.selectMachine}>Search</Button>
      </Table.Cell>
    </Table.Row> : <span></span>

    const { hasSelection } = this.props.filters;
    const widescreen = 2;
    const largeScreen = 2;
    const computer = 3;
    const tablet = 3;
    const mobile = 5;

    return (
      <Grid padded={false} className={ this.props.expanded && 'h-100 flex-container' }>
        <Grid.Row className={ this.props.expanded && 'flex-stretch' }>
        { hasSelection &&
          <Grid.Column widescreen={widescreen} computer={computer} largeScreen={largeScreen} tablet={tablet} mobile={mobile}>
              {this.leftControls()}
          </Grid.Column>
        }
          <Grid.Column 
            computer={ hasSelection ? 16 - computer : 16}
            widescreen={ hasSelection ? 16 - widescreen : 16}
            largeScreen={ hasSelection ? 16 - largeScreen : 16}
            tablet={ hasSelection ? 16 - tablet : 16}
            mobile={ hasSelection ? 16 - mobile : 16}
            className="flex-container"
          >
            <DataGrid
              activeRow={this.props.activeInstallation}
              headings={headerDef}
              data={data}
              fullHeight
              rowDef={rowDef}
              onRowClick={this.onRowClick}
              loading={this.state.loading}
            />
            <OptionsModal prefix={prefix} open={this.state.modalOpen} options={this.state.modalOptions} title={this.state.modalTitle} onClose={() => this.setState({ modalOpen: false })} handleReload={this.state.modalReload} onSave={this.state.modalSave} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}


const mapStateToProps = state => {
	return {
    installations: state.installations,
    filters: state.installationsFilters,
    eftUpdate: state.eftUpdate,
  	authorise: state.authorise,
    logIn: state.logIn,
    assetRemove: state.assetRemove,
    positionsAdd: state.positionsAdd,
    activeInstallation: state.activeInstallation
  };
};

export default connect(mapStateToProps, {
  fetchInstallations,
  fetchAsset,
  showSuccessAlert,
  setEft,
  setAuthorise,
  removeAsset,
  addPositions,
  setActiveInstallation,
  fetchInstallationsFilters,
})(SiteInstallations);
